import { all, put, takeEvery } from "redux-saga/effects";
import { getSummaryCount } from "../../Services/api";
import { setErrorStatus } from "../status/action";
import store from "../store";

function* setLocationsDataWorker(action) {
  yield setLocationsLoading(true);
  yield put({ type: "PUT_LOCATIONS_DATA", payload: { data: action.payload.data } });
  yield setLocationsLoading(false);
}

function* setWardAndZoneWorker(action) {
  yield put({ type: "PUT_ZONE_AND_WARD", payload: { data: action.payload.data } });
}

function* putLocationSummaryWorker(action) {
  yield put({
    type: "SET_GRAPH_SUMMARY_DATA",
    payload: {
      manPower: {
        captured: action.payload.manPowerAverage,
        lastEmployeeCaptured: action.payload.lastManPowerCapturedAverage
      }
    }
  });
}

function* getLocationSummaryWorker() {
  try {
    yield setLocationsLoading(true);

    const locationsState = store.getState().locations;
    let zoneCounts = {};
    if (locationsState.data) {
      for (const data of Object.values(locationsState.data)) {
        zoneCounts[data.zone] = zoneCounts[data.zone] ? zoneCounts[data.zone] + 1 : 1;
      }
    }

    yield put({ type: "SET_GRAPH_SUMMARY_DATA", payload: { zoneCounts } });
    yield setLocationsLoading(false);
  } catch (error) {
    setErrorStatus(error);
    yield setLocationsLoading(false);
  }
}

function* getWorkforceCountWorker(action) {
  try {
    yield put({ type: "SET_WORKFORCE_LOADING", payload: { loading: true } });

    const accessToken = store.getState().auth.data.accessToken;

    const now = Date.now();
    const from = action?.payload?.from ?? 0;
    const to = action?.payload?.to ?? now;

    const allowedZones = action?.payload?.allowedZones;
    // Firestore caps an "in" clause at 30 values.
    const zones = Array.isArray(allowedZones) && allowedZones.length > 0
      ? allowedZones.slice(0, 30)
      : null;

    const response = yield getSummaryCount({
      accessToken,
      collection: "captures",
      uniqueKey: "employee.id",
      type: "uniqueCount",
      query: {
        count: [
          "createdAt", ">=", from,
          "createdAt", "<=", to,
          "success", "==", true,
          ...(zones ? ["location.zone", "in", zones] : [])
        ]
      }
    });

    const present = response.count || 0;

    yield put({
      type: "SET_GRAPH_SUMMARY_DATA",
      payload: {
        employeeAttendance: {
          present,
          absent: 0,
          total: present,
          range: { from, to }
        }
      }
    });

    yield put({ type: "SET_WORKFORCE_LOADING", payload: { loading: false } });
  } catch (error) {
    yield put({ type: "SET_WORKFORCE_LOADING", payload: { loading: false } });
    setErrorStatus(error);
  }
}

export default function* locationsWatcher() {
  yield all([
    takeEvery("SET_LOCATIONS_DATA", setLocationsDataWorker),
    takeEvery("SET_ZONE_AND_WARD", setWardAndZoneWorker),
    takeEvery("PUT_LOCATION_SUMMARY_DATA", putLocationSummaryWorker),
    takeEvery("GET_LOCATION_SUMMARY", getLocationSummaryWorker),
    takeEvery("GET_WORKFORCE_COUNT", getWorkforceCountWorker)
  ]);
}

function* setLocationsLoading(bool) {
  yield put({ type: "SET_LOCATIONS_LOADING", payload: { loading: bool } });
}
